module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "content-box-small mg-form-fix"
  }, [_c('form', {
    staticClass: "margin-50",
    attrs: {
      "action": "index.html"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getLead.apply(null, arguments)
      }
    }
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger mg-fix",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n             ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', [_vm._v("CPF ou CNPJ:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumber),
      expression: "taxIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj|accountExists:cpf'),
      expression: "'required|cpfCnpj|accountExists:cpf'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.taxIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('taxIdNumber')))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isShow == 'SHOW') ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.typePerson == 'PERSON') ? _c('div', [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        'name': 'adhesion',
        'query': {
          'planId': '35'
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                              MANUAL PF\n                  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        'name': 'adhesion',
        'query': {
          'planId': '36'
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                              Automático PF\n                  ")])], 1) : _c('div', [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        'name': 'adhesion',
        'query': {
          'planId': '37'
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                              MANUAL PJ\n                  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        'name': 'adhesion',
        'query': {
          'planId': '38'
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                              Automático PJ\n                  ")])], 1)]) : _vm._e()])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": "/inicio"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Plano Caminhos do Paraná\n      ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', [_vm._v("Para aderir a esse plano é necessário estar na lista de isentos da Caminhos do Paraná, por isso digite seu CPF ou CNPJ para podermos continuar:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary mg-top-8 ",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Avançar\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "parana-way"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-a38f2440!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/parana-way.vue
// module id = 2197
// module chunks = 1